import { searchVehicles } from 'apis/vehicleApis'
import { AVAILABLE_INVENTORY_INIT_QUERY, SessionStorageKey } from 'common/constants'
import { resetChildrenFilters, selectChildrenFilter } from 'common/helpers'
import { OverlayLoader } from 'components/Loader'
import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { useDashboardStore } from 'store/useDashboardStore'
import { ISearchFilterResult } from 'types/vehicleTypes'
import { resetSRPFilter } from 'utils/menuUtils'
import { getSearchUrl } from 'utils/urlUtils'
import shallow from 'zustand/shallow'

interface IProps {
  loading: boolean
}
export const SearchSaleChannel = ({ loading: ContentLoading }: IProps) => {
  const [searching, setSearching] = useState(false)

  const { filters: ContentData } = useDashboardStore((state) => state, shallow)
  const [saleChannel, setSaleChannel] = useState<string[]>(null)
  const [searchFilters, setSearchFilters] = useState<ISearchFilterResult[]>([])

  useEffect(() => {
    if (!ContentLoading) {
      const channels = ContentData.find(
        (e) => e.DBFieldName === 'saleChannel' || e.FieldName === 'Sales Channel'
      )?.ChildrenFilter.map((item) => item.Value)
      setSearchFilters([...ContentData] as ISearchFilterResult[])
      if (!!channels) {
        setSaleChannel(channels)
      }
    }
  }, [ContentLoading])

  const handleChangeSaleChannel = (saleChannel: string) => {
    resetChildrenFilters(searchFilters)
    selectChildrenFilter(searchFilters, 'Sales Channel', saleChannel)
  }

  const handleRedirect = (filter?: ISearchFilterResult[]) => {
    resetSRPFilter()
    sessionStorage.setItem(SessionStorageKey.SEARCH_FILTERS, filter ? JSON.stringify(filter) : null)
    window.location.href = getSearchUrl()
  }

  const SubmitSearch = async () => {
    try {
      setSearching(true)
      const response = await searchVehicles({
        ...AVAILABLE_INVENTORY_INIT_QUERY,
        SearchQuery: { ...AVAILABLE_INVENTORY_INIT_QUERY.SearchQuery, SearchFilters: searchFilters }
      })
      if (response) {
        handleRedirect(searchFilters)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setSearching(false)
    }
  }

  return (
    <>
      <Formik initialValues={{ saleChannel: '0' }} onSubmit={SubmitSearch}>
        {(props) => (
          <Form onSubmit={props.handleSubmit} onReset={props.handleReset}>
            <Row>
              <Form.Group as={Col} xs={12} lg={8} sm={8} controlId="saleChannelSearch">
                <Row>
                  <Form.Label className="section-name" column sm="auto">
                    <h5>Sales Channel</h5>
                  </Form.Label>
                  <Col className="p-0">
                    <Form.Control
                      onChange={(e) => {
                        props.handleChange(e)
                        handleChangeSaleChannel(e.target.value)
                      }}
                      onBlur={props.handleBlur}
                      type="input"
                      as="select"
                      name="saleChannel"
                    >
                      <option value="0">Select</option>
                      {saleChannel?.map((e) => (
                        <option value={e} key={e}>
                          {e}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group as={Col} xs={12} lg={4} sm={4} className="pl-0">
                <Row noGutters className="mx-lg-0">
                  <Button type="submit" disabled={props.values.saleChannel === '0'} variant="primary" className="mx-2">
                    SEARCH
                  </Button>
                </Row>
              </Form.Group>
            </Row>
          </Form>
        )}
      </Formik>
      {searching && <OverlayLoader />}
    </>
  )
}
